import { QueryHookResult, useGenericQuery } from '../useGenericQuery'
import { queryKeys } from '../queryRegistry'
import { Project } from 'axiosApi/models';
import { useApi } from 'api/ApiProvider';
import Api from 'axiosApi/api';

export const useAssignedProjects = (idEmployee: number, endDate: Date): QueryHookResult<Project> => {
  const { projectApi }: Api = useApi()
  return useGenericQuery<Project>({
    queryKey: queryKeys.assignedProjects(idEmployee, endDate),
    queryFn: async (): Promise<Project[]> => {
      const response = await projectApi.apiVversionProjectGetByEmployeeIdIdGet(idEmployee, "1", endDate)
      const { data } = response?.data;
      return data?.queryResult || [];
    }
  })
}